import React, { useContext, useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { AuthTokenContext } from '../contexts/AuthTokenContext'
import communityService from '../../services/communityService'
import CreateCommunityPage from '../pageComponents/CreateCommunityPage/CreateCommunityPage'
import { AdminList, BasicList, CommunityList } from '../commonUIComponents/NavigationList'

const SideNavBar = () => {
  const { authToken } = useContext(AuthTokenContext)
  const [communities, setCommunities] = useState()
  const [loading, setLoading] = useState(true)
  const [openCreateCommunityModal, setOpenCreateCommunityModal] = useState(false)

  const fetchCommunities = () => {
    communityService.fetchJoinedCommunities()
      .then(res => setCommunities(res))
      .catch(err => console.log(err))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchCommunities()
  }, [])

  const createCommunityModalOpenHandler = () => {
    setOpenCreateCommunityModal(true)
  }
  const createCommunityModalCloseHandler = () => {
    setOpenCreateCommunityModal(false)
  }

  return (
    <Box pl={2} pr={2} sx={{ border: '1px solid', borderLeft: 0, borderTop: 0, borderColor: 'grey.800' }}>
      {openCreateCommunityModal && <CreateCommunityPage open={openCreateCommunityModal} onClose={createCommunityModalCloseHandler} submitOnSuccess={fetchCommunities} />}
      <BasicList/>
      {authToken
        ? (
          <>
            <CommunityList communities={communities} createCommunityModalOpenHandler={createCommunityModalOpenHandler} loading={loading}/>
            <AdminList/>
          </>
          )
        : undefined
      }
    </Box>
  )
}

export default SideNavBar
